var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"v-stack h-stretch gap-3"},[_c('div',{staticClass:"h-stack h-end"},[_c('button',{staticClass:"add",on:{"click":function($event){return _vm.$router.push('/storage/add')}}},[_vm._v("Add")])]),_c('div',{staticClass:"h-stack h-start gap-3"},[_c('label',{staticStyle:{"align-self":"center"}},[_vm._v("Internal:")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.showInternal),expression:"showInternal"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.showInternal)?_vm._i(_vm.showInternal,null)>-1:(_vm.showInternal)},on:{"change":function($event){var $$a=_vm.showInternal,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.showInternal=$$a.concat([$$v]))}else{$$i>-1&&(_vm.showInternal=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.showInternal=$$c}}}}),_c('label',{staticStyle:{"align-self":"center"}},[_vm._v("External:")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.showExternal),expression:"showExternal"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.showExternal)?_vm._i(_vm.showExternal,null)>-1:(_vm.showExternal)},on:{"change":function($event){var $$a=_vm.showExternal,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.showExternal=$$a.concat([$$v]))}else{$$i>-1&&(_vm.showExternal=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.showExternal=$$c}}}}),_vm._l((_vm.driveTypes),function(type){return _c('div',{key:type.type,staticClass:"h-stack gap-3 h-start"},[_c('label',{staticStyle:{"align-self":"center"}},[_vm._v(_vm._s(type.type)+":")]),_c('input',{directives:[{name:"model",rawName:"v-model",value:(type.show),expression:"type.show"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(type.show)?_vm._i(type.show,null)>-1:(type.show)},on:{"change":function($event){var $$a=type.show,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(type, "show", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(type, "show", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(type, "show", $$c)}}}})])})],2),_c('Table',{attrs:{"loading":_vm.loading,"items":_vm.filteredDrives,"defaultColumn":0,"css":"1fr 60px 100px 100px 70px 70px 100px","columns":[
      {
        name: 'Name',
        sort: 'alphabet',
        path: ['name'],
      },
      {
        name: 'Type',
        sort: 'alphabet',
        path: ['external'],
        formatType: 'boolean',
        format: ['External', 'Internal'],
      },
      {
        name: 'Storage Type',
        sort: 'alphabet',
        path: ['type'],
      },
      {
        name: 'Form Factor',
        sort: 'alphabet',
        path: ['formFactor'],
      },
      {
        name: 'Free (TB)',
        sort: 'numeric',
        path: ['tooltipFreeSpace'],
        styleFunction: (item) => {
          if (item.tooltipFreeSpace < 0.2) {
            return 'color: red';
          }
          if (item.tooltipFreeSpace < 1) {
            return 'color: #db7f00';
          }
          if (item.tooltipFreeSpace / item.size < 0.99) {
            return 'color: green';
          }
          return 'color: green; font-weight: bold';
        },
      },
      {
        name: 'Free %',
        sort: 'numeric',
        path: ['tooltipFreeSpacePercent'],
        format: ' %',
        styleFunction: (item) => {
          if (item.tooltipFreeSpace < 0.2) {
            return 'color: red';
          }
          if (item.tooltipFreeSpace < 1) {
            return 'color: #db7f00';
          }
          if (item.tooltipFreeSpace / item.size < 0.99) {
            return 'color: green';
          }
          return 'color: green; font-weight: bold';
        },
      },
      {
        name: 'Size (TB)',
        sort: 'numeric',
        path: ['size'],
        formatMap: (size) => size.toFixed(2),
      },
    ]},on:{"rowSelected":(item) => _vm.$router.push('/storage/detail/' + item._id)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }